import { KeyValue, KeyValuePipe, NgClass } from '@angular/common';
import { booleanAttribute, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
	BaseInput,
	BootstrapSize,
	FieldsetInput
} from '@app/shared/form/models';
import { sanitizeFormControlName } from '@app/shared/form/utils';
import { TranslateModule } from '@ngx-translate/core';
import { FormInputComponent } from './../../form-input/form-input.component';

@Component({
	selector: 'app-fieldset-input',
	styleUrls: ['./fieldset-input.component.scss'],
	template: `
		<fieldset [class.divider-bottom]="control.showBottomBorder">
			<legend>
				<div class="legend-title py-1 text-left">
					<span>{{ control.label | translate }}</span>
				</div>
			</legend>

			<div class="row mt-2">
				@for (
					field of control.controls
						| keyvalue: this.keyvaluePipeCompareFn;
					track field.key
				) {
					<div
						class="{{ getBsClass(field.value.size) }}"
						[ngClass]="{
							'd-none d-lg-block': field.value.inputType === 'nop'
						}"
					>
						<app-form-input
							[field]="field.value"
							[filter]="filter"
							[form]="form"
							[name]="controlId + '-' + field.key"
						></app-form-input>
					</div>
				}
			</div>
		</fieldset>
	`,
	standalone: true,
	imports: [NgClass, FormInputComponent, KeyValuePipe, TranslateModule]
})
export class FieldsetInputComponent {
	@Input({ required: true }) control: FieldsetInput;
	@Input({ transform: sanitizeFormControlName }) controlId = '';
	@Input({ transform: booleanAttribute }) filter: boolean;
	@Input() form: UntypedFormGroup;

	public keyvaluePipeCompareFn(
		a: KeyValue<string, BaseInput>,
		b: KeyValue<string, BaseInput>
	) {
		if (a.value.index > b.value.index) {
			return 1;
		}

		if (a.value.index < b.value.index) {
			return -1;
		}
		return 0;
	}

	/**
	 * 20240715- FIXME
	 */
	public getBsClass(size: string | BootstrapSize): string {
		if (!size) {
			return 'col-12';
		}
		if ('string' === typeof size) {
			return BootstrapSize.formPipe(size).toClass();
		} else if (size instanceof BootstrapSize) {
			return size.toClass();
		}

		return 'col-12';
	}
}
